import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataStateChangeEventArgs, FilterSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { DataScopesEnum, SubmissionStatusEnum, SubmissionTypeEnum, SubmissionStatusNumericEnum } from '../../shared/enums/index';
import { fadeInOut } from '../../shared/helpers/animations';
import { IServiceError } from '../../shared/models/index';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AuthorizationService, CustomerService, DeviceinventoryService, ExportDataService, SettingsService, StorageManagerService } from '../../shared/services/index';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { DataUtil } from '@syncfusion/ej2-data';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { FeatureService } from '../../shared/services/feature.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthWindowService } from  '../../shared/services/auth-window.service';

@Component({
    selector: 'app-manage-submission-items',
    templateUrl: './manage-submission-items.component.html',
    styleUrls: ['./manage-submission-items.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ManageSubmissionItemsComponent extends BaseGridComponent
  implements OnInit, AfterViewInit {
  data: any[];
  data$: Observable<DataStateChangeEventArgs>;
  resolverData: any[] | IServiceError;
  formatOptions: Object;
  selectedArray: any[] = [];
  filterSettings: FilterSettingsModel;
  dataScope: string;
  eSignatureResponse: any;
  eSignatureConfirmed = false;
  eSignatureErrorMessage = '';
  customer: any;
  userGuid: string;
  dataScopeEnum = DataScopesEnum;
  authChannel: BroadcastChannel | null = null;

  target = '#modalTarget';
  modalPosition: object = { X: 'center', Y: 'center' };
  modalWidth = '30%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  loginName: string;
  overlay: any;
  submissionTypeEnum = SubmissionTypeEnum;
  submissionStatusNumericEnum = SubmissionStatusNumericEnum;
  alertWidth = '15%';
  sppItem = false;
  dblClickDialogModalVisible = false;
  rejectModalVisible = false;
  sendModalVisible = false;



  @ViewChild('submittemplate', { static: true })
  public toolbarSubmitTemplate: any;

  @ViewChild('rejecttemplate', { static: true })
  public toolbarRejectTemplate: any;

  @ViewChild('dialog', { static: true })
  public dialog: DialogComponent;

  @ViewChild('rejectDialog', { static: true })
  public rejectDialog: DialogComponent;

  @ViewChild('dblClickDialog', { static: true })
  public dblClickDialog: DialogComponent;

  @ViewChild('tooltipObj') tooltipObj: TooltipComponent;

  gridComplete = false;
  appVarId: number;
  healthAuthority: DataScopesEnum;
  modelTabCounter = 0;
  deviceTabCounterNewUdi = 0;
  deviceTabCounterChanges = 0;
  deviceRegistrationCount = 0;
  updateTabCounter = 0;
  rejectionNoteProvided = false;
  rejectionSubmitted = false;
  confirmClicked = false;
  doubleClicked = false;
  clickCount = 0;
  activeTab = '';
  tabs = ['newBudi', 'newUdi', 'deviceRegistrationTab', 'changes'];

  constructor (
    public service: DeviceinventoryService,
    public storage: StorageManagerService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    public cdref: ChangeDetectorRef,
    public authorizationService: AuthorizationService,
    public authenticationService: AuthenticationService,
    public appGlobals: AppGlobals,
    public exportDataService: ExportDataService,
    public settingsService: SettingsService,
    public customerService: CustomerService,
    public featureService: FeatureService,
    private oidc: OidcSecurityService,
    private authWindowService: AuthWindowService
  ) {
    super(
      service,
      storage,
      router,
      activatedRoute,
      toastr,
      cdref,
      authorizationService,
      authenticationService,
      appGlobals,
      exportDataService,
      settingsService,
      customerService,
      featureService
    );
  }

  ngAfterViewInit(): void {
    this.cdref.detectChanges();
  }

  /**
* Every time the data state changes (resize, reorder, reload, etc.) this event gets triggered
* and originates the grid parameters. The parameter showInColumnChooser should be present
* for all columns in the columnOptions array. Default columns should be set to false to
* prevent the user from hiding them.
* Called from the html on the grid's dataStateChange event
* @param  {DataStateChangeEventArgs} state
* @returns void
*/
  public dataStateChange(state: DataStateChangeEventArgs): void {
    this.setDeviceCounter();
    this.setTabCounter();
  }

  private preExecute(state: DataStateChangeEventArgs) {

    if (this.resolverData[0]) {

      this.appDefaults = this.resolverData[0].channelGrids.find(a => a.applicationVariantId === this.appVarId).manageSubmissionItemsGrid;

      this.pageOptions = {
        pageSize: this.appDefaults.defaultPageSize,
        pageCount: this.appDefaults.pageCount,
        pageSizes: this.appDefaults.pageSizes
      };

      this.state = {
        skip: state && state.skip ? state.skip : 0,
        take: 0,
        sorted: []
      };
    } else {
      this.pageOptions = {
        pageSize: 25,
        pageCount: 6,
        pageSizes: [25, 50, 100]
      };

      // get all rows - 0 is stage max
      this.state = { skip: 0, take: 0, sorted: [] };
    }
  }

  dataBound(args: any) {

    // if (this.grid.currentViewData.length > 0) {
    //   this.gridComplete = true;
    // }

    const selectAllCheckBox = document.getElementsByClassName('e-headercell')[0];

    if (selectAllCheckBox) {
      selectAllCheckBox.classList.add('checkbox-header-manage-di');
    }

    const gridchkbox = document.getElementsByClassName('e-gridchkbox')[0];

    if (gridchkbox) {
      gridchkbox.classList.add('checkbox-header-manage-di');
    }

    const ccDiv = document.getElementsByClassName('e-ccdlg')[0];
    if (ccDiv) {
      ccDiv.classList.add('wide-column-chooser');
      ccDiv.classList.remove('columnChooserMarginTop');
    }

    this.setDeviceCounter();
  }

  ngOnInit() {

    this.permissionsConst = this.appGlobals.permissions;

    this.timerInterval = this.serverSettings.hasOwnProperty('APIPollTimeIntervalInMillSeconds') ?
      +this.serverSettings.APIPollTimeIntervalInMillSeconds : 5000;

    this.storage.write('activeTab', 'device');
    this.userGuid = this.storage.read('userGuid');

    if (!this.userGuid) {
      this.router.navigate(['error', 'User is not logged in']);
    }

    const customer = this.storage.read('currentCustomer');
    if (customer) {

      this.customer = typeof customer === 'object' ? customer : JSON.parse(customer);
    } else {
      this.router.navigate(['/home']);
    }

    try {
      this.authChannel = new BroadcastChannel('auth_channel');
      this.authChannel.onmessage = (event) => {
        this.processAuthData(event.data);
      };
    } catch (e) {
      console.error('BroadcastChannel not supported', e);
    }

    this.formatOptions = { type: 'dateTime', format: 'MM/dd/yyyy hh:mm a' };
    this.dataScope = this.storage.read('dataScope');

    switch (this.dataScope) {
      case 'eudamed':
        this.healthAuthority = this.dataScopeEnum.EUDAMED;
        this.activeTab = 'newBudi'
        break;

      case 'swissdamed':
        this.healthAuthority = this.dataScopeEnum.SWISSDAMED;
        this.activeTab = 'deviceRegistrationTab';
        break;

      case 'china-udi':
        this.healthAuthority = this.dataScopeEnum.CHINA;
        this.activeTab = 'deviceRegistrationTab';
        break;

      case 'southkorea-udi':
        this.healthAuthority = this.dataScopeEnum.SKOREA;
        this.activeTab = 'deviceRegistrationTab';
        break;

      case 'us-udi':
        this.healthAuthority = this.dataScopeEnum.US;
        this.activeTab = 'deviceRegistrationTab';
        break;

      case 'saudiarabia-udi':
        this.healthAuthority = this.dataScopeEnum.SA;
        this.activeTab = 'deviceRegistrationTab';
        break;
      case 'australia-udi':
        this.healthAuthority = this.dataScopeEnum.AU;
        this.activeTab = 'deviceRegistrationTab';
        break;
      case 'brazil-udi':
        this.healthAuthority = this.dataScopeEnum.BRAZIL;
        this.activeTab = 'deviceRegistrationTab';
        break;
    }

    this.filterSettings = {
      type: 'Menu',
      operators: {
        stringOperator: [
          { value: 'contains', text: 'contains' },
          { value: 'startsWith', text: 'starts with' },
          { value: 'endsWith', text: 'ends with' },
          { value: 'equal', text: 'equal' }
        ],
        dateOperator: [
          { value: 'equal', text: 'equal' }
        ],
      }
    };

    this.selectionOptions = { cellSelectionMode: 'Flow', type: 'Multiple', mode: 'Row', checkboxMode: 'Default', checkboxOnly: true };

    if (!this.dataScope) {
      this.dataScope = this.customer.applicationVariants[0].applicationVariantName.toLowerCase();
    }

    this.appVarId = this.customer.applicationVariants.find(ap => ap.applicationVariantName.toLowerCase() === this.dataScope.toLowerCase()).applicationVariantId;

    this.loginName = this.storage.read('userData').preferred_username;

    // get data prepared by the resolver
    this.resolverData = this.activatedRoute.snapshot.data[
      'submissionItems'
    ];

    this.preExecute(this.state);

    this.data$ = this.service.getSubmissionItems(
      'ReadyForApproval',
      this.submissionItemsKey(this.dataScope),
      this.customer.customerId,
      this.dataScope,
      this.state,
      this.grid
    );

    this.subscription = this.data$.subscribe(response => {
      const objects = response;
      // const objects = this.resolverData[1]; // mock
      this.data = DataUtil.parse.parseJson((objects as any).objectList);
      // this.modelTabCounter = this.data.length;
      this.gridComplete = true;
      this.setTabCounter();

      this.sortSettings = { columns: [{ field: 'changeDate', direction: 'Descending' }] };

      // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
      this.initTabIndex();

      this.selectedItems = [];
      this.storage.write('selectedItems', this.selectedItems);
    });

    window.addEventListener('message', this.receiveMessage, false);
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  submissionItemsKey(dataScope: string) {

    let retVal;

    switch (dataScope) {
      case this.dataScopeEnum.EUDAMED.toLowerCase():

        // pass empty so all types are retrieved and filtered by the grids
        retVal = '';
        break;
      case this.dataScopeEnum.SWISSDAMED.toLowerCase():

        retVal = 'CreateUpdateModelAndDevice';
        break;
      case this.dataScopeEnum.CHINA.toLowerCase():

        retVal = 'Submit';
        break;
      case this.dataScopeEnum.SA.toLowerCase():

        retVal = 'Draft';
        break;

      case this.dataScopeEnum.US.toLowerCase():
        retVal = 'GUDIDSubmission';
        break;

      case this.dataScopeEnum.SKOREA.toLowerCase():

        retVal = 'SearchTheModel';
        break;

      case this.dataScopeEnum.AU.toLocaleLowerCase():
        retVal = 'AusUDIDSubmission';
        break;

      case this.dataScopeEnum.BRAZIL.toLocaleLowerCase():
        retVal = 'BrazilUDIDSubmission';
        break;
    }

    return retVal;
  }

  submissionItemsKeyTabId(dataScope: string, tabId: string): number[] {

    let retVal;

    switch (dataScope) {
      case this.dataScopeEnum.EUDAMED.toLowerCase():


        switch (tabId) {
          case 'newBudi':
            retVal = [this.submissionTypeEnum.MdrCreateNewDeviceModel];
            break;

          case 'newUdi':
            retVal = [this.submissionTypeEnum.MdrAddDevicesToRegisteredModel];
            break;

          case 'changes':
            retVal = [this.submissionTypeEnum.MdrUpdateDevice, this.submissionTypeEnum.MdrUpdateModel];
            break;
        }

        break;
      case this.dataScopeEnum.SWISSDAMED.toLowerCase():
        retVal = [this.submissionTypeEnum.CreateUpdateModelAndDevice];
        break;

      case this.dataScopeEnum.CHINA.toLowerCase():
        retVal = [this.submissionTypeEnum.Submit];
        break;

      case this.dataScopeEnum.SA.toLowerCase():

        retVal = [this.submissionTypeEnum.Draft];
        break;

      case this.dataScopeEnum.US.toLowerCase():
        retVal = [this.submissionTypeEnum.GUDIDSubmission];
        break;

      case this.dataScopeEnum.SKOREA.toLowerCase():

        retVal = [this.submissionTypeEnum.SearchTheModel];
        break;

      case this.dataScopeEnum.AU.toLocaleLowerCase():
        retVal = [this.submissionTypeEnum.AusUDIDSubmission];
        break;

      case this.dataScopeEnum.BRAZIL.toLocaleLowerCase():
        retVal = [this.submissionTypeEnum.BrazilUDIDSubmission];
        break;
    }

    return retVal;
  }

  tabChanged(event) {

    this.activeTab = event.nextId;
    this.data = [];
    this.gridComplete = false;
    this.deviceCount = -1;

    // deselect rows from the previous tab
    this.selectRowsAll(false);

    this.preExecute(this.state);

    this.data$ = this.service.getSubmissionItems(
      'ReadyForApproval',
      this.submissionItemsKey(this.dataScope),
      this.customer.customerId,
      this.dataScope,
      this.state,
      this.grid
    );

    this.subscription = this.data$.subscribe(response => {
      const objects = response;
      // const objects =  this.resolverData[1]; // mock
      this.data = DataUtil.parse.parseJson((objects as any).objectList);
      this.gridComplete = true;
      this.setDeviceCounter();
      this.setTabCounter(event.nextId);
    });

    this.sortSettings = { columns: [{ field: 'changeDate', direction: 'Descending' }] };
  }

  setTabCounter(nextId?: string) {

    if (nextId) {

      if (this.healthAuthority === this.dataScopeEnum.EUDAMED) {
        switch (nextId) {
          case 'newBudi':
            this.modelTabCounter = this.data.filter(d => +d.submissionTypeCode === 1).length;
            break;
          case 'newUdi':
            this.deviceTabCounterNewUdi = this.data.filter(d => +d.submissionTypeCode === 2).length;
            break;
          case 'changes':
            // 4 MDR - Update Model, and status 3 MDR - Update Device will be added
            this.deviceTabCounterChanges = this.data.filter(d => +d.submissionTypeCode === 4 || +d.submissionTypeCode === 3).length;
            break;
        }
      } else {
        this.deviceRegistrationCount = this.data.length;
      }
    } else {

      this.tabs.forEach(tabName => {
        this.setTabCounter(tabName);
      });
    }
  }

  toolbarButtonAccess() {

    this.toolbar = [
      { template: this.toolbarSubmitTemplate, id: 'sendtochannel' },
      { template: this.toolbarRejectTemplate, id: 'rejectselected' },
    ];
  }

  toolbarClick(args: ClickEventArgs): void {

    switch (args.item.id) {
      case 'sendtochannel':

        this.sendToChannel(this.dataScope);
        break;

      case 'rejectselected':

        this.rejectSelected();
        break;
    }
  }

  rejectSelected() {

    if (this.checkIsSelected() || (this.selectedItems && this.selectedItems.length)) {

      // this.rejectDialog.show();
      this.rejectModalVisible = true;
    } else {

      this.toastr.warning(
        `Nothing is selected for the Rejection.`,
        '',
        { closeButton: true }
      );
    }
  }


  itemClicked(itemType, data) {

    let diId;
    let issuingAgency;
    let submissionGuid;

    if (data) {

      this.sppItem = !!data.systemProcedurePackSrn;
      submissionGuid = data.submissionGuid;
      if (itemType === 'model') {
        diId = data.modelIdentifier;
        issuingAgency = data.modelIssuingAgency;
      } else {

        diId = data.deviceIdentifier;
        issuingAgency = data.deviceIssuingAgency;
      }

      // special handling for opening a new tab
      const url = this.router.serializeUrl(this.router.createUrlTree(['submissions/submissionitemdetails', itemType, issuingAgency, data.modelRevision, data.deviceRevision, data.distributionChannelDesc.toLowerCase()], { queryParams: { 'id': submissionGuid, sppItem: this.sppItem, applicableLegislation: data.applicableLegislation } }));
      window.open(url, '_blank');
    }
  }
   
  itemSubmissionType(data): string {

    let retVal;

    retVal = data.submissionTypeCode === SubmissionTypeEnum.MdrUpdateModel ? 'model' : 'device';

    return retVal;
  }

  /**
  * Triggers when any grid action begins
  * @param  {any} args
  */
  actionBegin(args: any) {

    const type = args.requestType;

    switch (type) {
      case 'paging':
        this.storeSelectedItems();
        break;

      case 'filterbeforeopen':
        break;

      default:
        break;
    }
  }

  complete(args: any) {
    switch (args.requestType) {
      case 'refresh':
        this.setDeviceCounter();
        this.setTabCounter();
        this.toolbarButtonAccess();
        break;
      case 'sorting':
        break;
      case 'paging': case 'reorder':
        this.persistSelectedRows();

        if (!this.selectAllChecked && !this.deselectAllChecked) {
          this.persistSelectedRows();
        }

        // if SelectAll is selected - select rows on the page on paging event
        if (this.selectAllChecked) {
          this.selectRowsAll(this.selectAllChecked);
        }

        // if SelectAll is intentionally unchecked - unselect rows - overrides persistance
        if (this.deselectAllChecked) {
          this.selectRowsAll(false);
        }
        break;
      case 'filtering':

        if (this.grid && this.grid.columns && this.grid.columns.length > 0) {
          this.setDeviceCounter();
          this.setTabCounter();

          this.selectRowsAll(false);
        }
        break;
      case 'filterafteropen':

        if (args.columnType === 'date') {
          args.filterModel.dlgDiv.querySelector(
            '.e-datepicker'
          ).ej2_instances[0].format = 'MM/dd/y';
        }
        break;
    }
  }

  sendToChannel(channel: string) {

    if (this.checkIsSelected() || (this.selectedItems && this.selectedItems.length)) {

      this.sendModalVisible = true;
      this.dialog.show();
    } else {

      this.toastr.warning(
        `Nothing is selected for the Registration.`,
        '',
        { closeButton: true }
      );
    }
  }

  confirmedClicked() {
    this.confirmClicked = true;
    this.eSignatureErrorMessage = '';
    if (this.authWindowService.authWindow && !this.authWindowService.authWindow.closed) {
      this.authWindowService.authWindow.focus();
      return;
    }

    const width = 600;
    const height = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    this.authWindowService.authWindow = window.open(`${window.location.origin}/external-login`, 'eSignature Authentication', `width=${width},height=${height},top=${top},left=${left}`);

    if (!this.authWindowService.authWindow) {
      this.confirmClicked = false;
      this.eSignatureErrorMessage ='Authentication window was blocked. Please allow pop-ups for this site.';
    }
  }

  onDialogClose() {
    this.eSignatureConfirmed = true;  
    this.confirmClicked = false;
    this.doubleClicked = false;
    this.sendModalVisible = false;
    this.dialog.hide();
  }
  // catches double click event vs the single click
  buttonDoubleClick(event) {
    this.doubleClicked = true;
    this.eSignatureErrorMessage = 'The button cannot be double clicked';
    this.dblClickDialog.show();
    this.dblClickDialogModalVisible = true;
    event.stopPropagation();
    event.preventDefault();
    return;
  }

  onDblClickDialogClose(event) {

    this.doubleClicked = false;
    this.dblClickDialogModalVisible = false;
  }

  dblClickDialogClose(event) {

    if (this.dblClickDialog) {
      this.dblClickDialog.hide();
      this.dblClickDialogModalVisible = false;
    }
  }

  // Time out to catch the single click
  eSigConfirmTimeout() {

    setTimeout(() => {
      if (!this.doubleClicked) {
        this.eSigConfirm();
      } else {
        this.confirmClicked = false;
      }
    }, 1000);
  }

  eSigConfirm() {

    this.selectedRecords = [];
    const paramsContainer = {};

    const dialog = document.getElementById('dialog');

    if (dialog) {

      // signature confirmed. Now determine if it's a manual selection or "Select All"
      const paramsContainerForRegistration = {};

      if (this.checkIsSelected() || (this.selectedItems && this.selectedItems.length)) {

        if (this.selectAllChecked) {

          const viewModel = this.prepareSelectAllViewModel('sendtochannel');

          this.subscription = this.service.sendToChannelSelectAll(viewModel).subscribe(response => {

            const registrationResult: any = response;

            if (registrationResult) {

              this.preExecute(this.state);

              this.data$ = this.service.getSubmissionItems(
                'ReadyForApproval',
                this.submissionItemsKey(this.dataScope),
                this.customer.customerId,
                this.dataScope,
                this.state,
                this.grid
              );

              // Setting the selected items count before passing to print in the toastr
              let selectedItemsCount = this.getSelectedItemsCount();

              this.subscription = this.data$.subscribe(list => {
                const objects = list;
                this.data = DataUtil.parse.parseJson((objects as any).objectList);

                // length is temp. When data.count is returned from the api - will be replaced
                this.setDeviceCounter();
                this.setTabCounter();
                this.toastr.success(`${ selectedItemsCount } submission items were successfully submitted to ${ this.dataScope.toUpperCase() }. To monitor submission progress, please visit the Submissions History.`,
                  '', { closeButton: true });

                this.confirmClicked = false;
              });

            } else {

              this.toastr.error(`Error occured during registration.`, '',
                { timeOut: 0, closeButton: true }
              );
            }

            this.postActionReset();
          });

        } else {

          paramsContainerForRegistration['customerId'] = this.customer.customerId;
          paramsContainerForRegistration['changeUserGuid'] = this.userGuid;
          paramsContainerForRegistration['channel'] = this.dataScope;
          paramsContainerForRegistration['submissionIds'] = this.selectedItems;

          this.subscription = this.service.sendToChannelForRegistration(paramsContainerForRegistration)?.subscribe(response => {
            const registrationResult: any = response;

            if (registrationResult) {

              this.preExecute(this.state);

              this.data$ = this.service.getSubmissionItems(
                'ReadyForApproval',
                this.submissionItemsKey(this.dataScope),
                this.customer.customerId,
                this.dataScope,
                this.state,
                this.grid
              );
              this.toastr.info('Your request has been submitted', '', { closeButton: true });
              this.subscription = this.data$.subscribe(list => {
                const objects = list;
                this.data = DataUtil.parse.parseJson((objects as any).objectList);

                // length is temp. When data.count is returned from the api - will be replaced
                this.setDeviceCounter();
                this.setTabCounter();
                this.toastr.success(`${ this.selectedItems.length } submission items were successfully submitted to ${ this.dataScope.toUpperCase() }. To monitor submission progress, please visit the Submissions History `,
                  '', { closeButton: true });

                this.confirmClicked = false;
                this.selectedItems = [];
                this.storage.write('selectedItems', this.selectedItems);
              });

            } else {

              this.toastr.error(`Error occured during registration.`, '',
                { timeOut: 0, closeButton: true }
              );
            }
          });

        }

        // post action
        this.sendModalVisible = false;
        this.dialog.hide();
      }
    }
  }

  eSigCancel(event) {
    this.sendModalVisible = false;
    this.dialog.hide();
  }

  rejectCancel(event) {

    this.rejectionSubmitted = false;
    this.rejectModalVisible = false;
    this.rejectDialog.hide();
  }

  onKeyUp(event) {
    this.rejectionNoteProvided = true;
  }

  rejectSubmit() {

    let rejectNoteValue;
    const paramsContainerForRejection = {};

    this.rejectionSubmitted = true;

    const rejectNoteTA: any = document.getElementById('taRejectNote');

    if (rejectNoteTA) {
      rejectNoteValue = rejectNoteTA.value;

      if (!rejectNoteValue) {
        this.rejectionNoteProvided = false;
        return;
      } else {
        this.rejectionNoteProvided = true;
      }
    }

    // Get submissionIDs from the approved array for Eudamed and this.selectedRecords for China and SKorea
    if (this.checkIsSelected() || (this.selectedItems && this.selectedItems.length)) {

      if (this.selectAllChecked) {

        // prepare a viewModel for the backend to process rows on the backend
        let viewModel = this.prepareSelectAllViewModel('rejectselected');

        // add a reject note to the view model
        viewModel['note'] = rejectNoteValue;

        this.subscription = this.service.sendForRejectionSelectAll(viewModel)?.subscribe(response => {

          const rejectionResult: any = response;

          if (rejectionResult) {

            this.preExecute(this.state);

            this.data$ = this.service.getSubmissionItems(
              'ReadyForApproval',
              this.submissionItemsKey(this.dataScope),
              this.customer.customerId,
              this.dataScope,
              this.state,
              this.grid
            );

            // Setting the selected items count before passing to print in the toastr
            let selectedItemsCount = this.getSelectedItemsCount();

            this.subscription = this.data$.subscribe(list => {
              const objects = list;
              this.data = DataUtil.parse.parseJson((objects as any).objectList);

              // length is temp. When data.count is returned from the api - will be replaced
              this.setDeviceCounter();
              this.setTabCounter();

              if (this.rejectDialog) {
                this.rejectModalVisible = false;
                this.rejectDialog.hide();
              }

              this.toastr.success(`${ selectedItemsCount } submission items were successfully submitted for rejection.`, '', { closeButton: true });

              this.selectedItems = [];
              this.storage.write('selectedItems', this.selectedItems);
              this.sendModalVisible = false;
              this.dialog.hide();
            });

          } else {

            this.toastr.error(`Error occured during rejection.`, '',
              { timeOut: 0, closeButton: true }
            );
          }

          this.postActionReset();
        });

      } else {

        paramsContainerForRejection['customerId'] = this.customer.customerId;
        paramsContainerForRejection['changeUserGuid'] = this.userGuid;
        paramsContainerForRejection['channel'] = this.dataScope;
        paramsContainerForRejection['submissionIds'] = this.selectedItems;
        paramsContainerForRejection['note'] = rejectNoteValue;

        this.subscription = this.service.sendForRejection(paramsContainerForRejection)?.subscribe(response => {
          const rejectionResult: any = response;

          if (rejectionResult) {

            this.preExecute(this.state);

            this.data$ = this.service.getSubmissionItems(
              'ReadyForApproval',
              this.submissionItemsKey(this.dataScope),
              this.customer.customerId,
              this.dataScope,
              this.state,
              this.grid
            );
            this.toastr.info('Your request has been submitted', '', { closeButton: true });
            this.subscription = this.data$.subscribe(list => {
              const objects = list;
              this.data = DataUtil.parse.parseJson((objects as any).objectList);

              // length is temp. When data.count is returned from the api - will be replaced
              this.setDeviceCounter();
              this.setTabCounter();

              if (this.rejectDialog) {
                this.rejectModalVisible = false;
                this.rejectDialog.hide();
              }

              this.toastr.success(`${ this.selectedItems.length } submission items were successfully submitted for rejection.`, '', { closeButton: true });

              this.sendModalVisible = false;
              this.dialog.hide();
              this.selectedItems = [];
              this.storage.write('selectedItems', this.selectedItems);
            });

          } else {

            this.toastr.error(`Error occured during rejection.`, '',
              { timeOut: 0, closeButton: true }
            );
          }
        });
      }
    }
  }

  prepareSelectAllViewModel(action: string) {

    this.queryCriteria = this.generateSelectAllCriteria(action);

    const filterString = this.queryCriteria ? JSON.stringify(this.queryCriteria) : '';

    let viewModel = {
      'customerId': this.customer.customerId,
      'changeUserGuid': this.userGuid,
      'channel': this.dataScope,
      'submissionStatus': SubmissionStatusNumericEnum.readyForApproval,
      'submissionTypes': this.submissionItemsKeyTabId(this.dataScope, this.activeTab),
      'jsonFilter': filterString
    };

    return viewModel;
  }

  persistSelectedRows() {

    this.grid.selectRows([]);
    const selectedItemIndexes: number[] = [];
    const selectedItems = this.storage.read('selectedItems');

    if (selectedItems && selectedItems.length > 0) {

      const gridObj = this.grid;
      const records = gridObj.getCurrentViewRecords();

      selectedItems.forEach(item => {

        const row = records.find(r => r['submissionId'] === item);

        if (row) {

          const index = records.indexOf(row);

          if (index >= 0) {
            selectedItemIndexes.push(index);
          }
        }
      });

      if (selectedItemIndexes.length > 0) {

        this.grid.selectRows(selectedItemIndexes);
      }
    }
  }

  rowSelected(row, field) {

    if (row.isInteracted) {

      if (row && row.data) {

        // multiple selection
        if (row.data.length) {

          row.data.forEach(item => {
            if (!this.selectedItems.includes(item[field])) {
              this.selectedItems.push(item[field]);
            }
          });

          this.storage.write('selectedItems', this.selectedItems);
        } else {

          if (!this.selectedItems.includes(row.data[field])) {
            this.selectedItems.push(row.data[field]);

            this.storage.write('selectedItems', this.selectedItems);
          }
        }

        this.confirmClicked = false;
      }
    }
  }

  storeSelectedItems() {

    const selectedRecords = this.grid.getSelectedRecords();

    if (selectedRecords.length > 0) {

      // add selected records
      selectedRecords.forEach(element => {

        if (!this.selectedItems.includes(element['submissionId'])) {
          this.selectedItems.push(element['submissionId']);
        }
      });
    }

    this.storage.write('selectedItems', this.selectedItems);
  }

  onRejectDialogClose(event) {

    const ta: any = document.getElementById('taRejectNote');

    if (ta) {
      ta.value = '';
    }
  }

  // override of the baseGrid. Sometimes the control is not available
  setDeviceCounter() {

    this.cdref.detectChanges();

    const pageCountMsg = document.getElementsByClassName('e-pagecountmsg')[0];

    if (pageCountMsg) {
      this.pageItemCounter = (pageCountMsg as any).innerText;

      this.deviceCount = this.pageItemCounter.substr(this.pageItemCounter.indexOf('(') + 1, this.pageItemCounter.indexOf(' item') - 1);
    } else {

      this.deviceCount = -1;
    }
  }

  sentToChannelButtonText(dataScope): string {

    let buttonText;

    switch (dataScope) {

      case this.dataScopeEnum.US:
        buttonText = 'FDA GUDID';
        break;

      case this.dataScopeEnum.AU:
        buttonText = 'TGA AusUDID';
        break;

      default:
        buttonText = dataScope;
        break;
    }

    return buttonText;
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.authChannel) {
      this.authChannel.close();
    }
    window.removeEventListener('message', this.receiveMessage);

    // clear the selected items storage
    this.storage.write('selectedItems', []);
  }

  processAuthData(data: any) {
    if (data?.preferred_username === undefined) {
      return;
    }
    const btnConfirm: any = document.getElementById('btnConfirm');
    if (data && data.preferred_username && data.preferred_username.toLowerCase() === this.loginName.toLowerCase()) {
      this.eSigConfirm();
      this.onDialogClose();
    } else {
      if (btnConfirm) {
          btnConfirm.disabled = false;
      }
      this.toastr.error(`eSignature username must match logged in username`);
      this.eSignatureErrorMessage = "eSignature username must match logged in username";
      this.onDialogClose();
    }
  }

  receiveMessage = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) {
      return; // Don't process messages from unknown origins
    }
    this.processAuthData(event.data);
  };
}
